module.exports = "/assets/dist/images/sycBannerImage-sm.jpg?ea703f0f76d0ea6e3d46f9788499903b";